import { TableStore } from 'ynf-core-engine/stores'
import { extendObservable, toJS } from 'mobx';

export default class NewTableStore extends TableStore {
  // [x: string]: any;
  constructor (...props: any) {
    super(...props, null, props[1].referInputProps.valueField)
    const referInputProps = props[1].referInputProps

    extendObservable(this, {
      collect: referInputProps.openCollect
    })
  }

  getReferSelectedRows () {
    const value = toJS(this.getSelectedRows()).map((e: any) => e.data)
    return value
  }

  getActiveByRowKey (key: string | number) {
    const rowStore = this.getRowByKey(key);
    // 如果开启跨页多选，选择的数据存储到multiplePageSelectedData 中
    return rowStore?.getValue();
  }

  selectedByRowKeys (keys: any) {
    this.unSelectAll()
    while (keys.length) {
      this.selectedByRowKey(keys.pop())
    }
  }

  async onCollectClick (cell: any, e: any) { // 收藏点击
    const val = { ...cell }
    let res
    if (cell.refHotType) { // 取消
      res = await this.rootStore.actions.delFavorite.doAction(val)
      val.refHotType = 0
    } else {
      res = await this.rootStore.actions.setFavorite.doAction(val)
      val.refHotId = val.id
      val.refHotType = 1
    }
    if (!res) return
    this.updateRow(cell.rowStore.rowKey, val)
  }

  /**
   * 设置选择的值,常用场景，供组件选择使用
   * @param rows 行数组
  */
  setReferSelectRowKeys(rows: any = []): void {
    // 清空设置所有状态为false
    this.unSelectAll();
    // 设置新数据为selected状态
    rows.forEach((row: any) => {
      if (this.getRowByKey(row[this.primaryKey])) {
        this.getRowByKey(row[this.primaryKey]).setSelected();
      } else { // 跨页的数据
        // eslint-disable-next-line new-cap
        // this.multiplePageSelectedData.push(this.parseRow({[this.primaryKey]: row}));
        this.multiplePageSelectedData.push(this.parseRow(row));
      }
    });
  }
}
